var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCutlery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-11 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121 478c25 15 54 26 84 31l73 1c30-4 59-14 85-28l72-60a245 245 0 1 0-386-9zm0 0",
    fill: "#1d3260"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M431 210c-9 7-21 12-32 12-12 0-23-5-33-12 5 9 21 43 14 91h38c-8-48 8-82 13-91zm0 0",
    fill: "#b8dcf2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M416 266c-1 7-6 12-13 12h-9c-6 0-12-5-13-12 1 11 1 23-1 35h38c-2-12-3-24-2-35zm0 0",
    fill: "#89c2e5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M250 9c-73 31-66 204-64 237 0 4 2 7 5 8l6 3c16 8 26 24 26 42v5h39V18c0-7-7-11-12-9zm0 0",
    fill: "#b8dcf2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M231 275c-6 0-13-2-18-5 7 8 10 18 10 29v5h39v-47c-6 11-17 18-31 18zm0 0",
    fill: "#89c2e5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M250 10c-36 15-53 65-60 116l9-3c5-2 10-7 11-13 8-40 24-77 52-92 0-7-7-11-12-8zm0 0",
    fill: "#deeefa"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M422 300h-47c-3 0-5 3-5 6v22c0 3 2 6 5 6h47c3 0 6-3 6-6v-22c0-3-3-6-6-6zm0 0",
    fill: "#fecf2b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M396 317c0-9 8-17 17-17h-38c-3 0-5 3-5 6v22c0 3 2 6 5 6h38c-9 0-17-8-17-17zm0 0",
    fill: "#fabd2b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M435 422v-80c0-5-5-9-10-9h-53c-5 0-9 4-9 9v140c27-15 52-36 72-60zm0 0",
    fill: "#ee3346"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M265 300h-47c-3 0-6 3-6 6v22c0 3 3 6 6 6h47c3 0 6-3 6-6v-22c0-3-3-6-6-6zm0 0",
    fill: "#fecf2b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M239 317c0-9 8-17 17-17h-38c-3 0-6 3-6 6v22c0 3 3 6 6 6h38c-9 0-17-8-17-17zm0 0",
    fill: "#fabd2b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M268 333h-53c-5 0-10 4-10 9v167a247 247 0 0 0 73 1V342c0-5-5-9-10-9zm0 0",
    fill: "#ee3346"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#b8dcf2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 169L45 9a9 9 0 1 0-17-1l-8 142c4 7 10 13 17 19zm0 0M132 168c7-6 13-12 17-19L141 8a9 9 0 1 0-17 1zm0 0M95 182v1l18-4c1-10 0-27-3-170 0-5-4-9-9-9s-9 4-9 9c3 165 4 162 3 173zm0 0M74 183v-1c-1-11 0-9 3-173a9 9 0 0 0-18 0c-3 141-4 159-3 170l18 4zm0 0M111 224c-6 2-13 4-19 4H77c-6 0-13-2-19-4 6 16 13 43 8 77h38c-6-34 1-61 7-77zm0 0"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102 266c-1 7-7 12-13 12h-9c-6 0-12-5-13-12 1 11 0 23-1 35h38c-2-12-3-24-2-35zm0 0",
    fill: "#89c2e5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M108 300H61c-3 0-6 3-6 6v22c0 3 3 6 6 6h47c3 0 6-3 6-6v-22c0-3-3-6-6-6zm0 0",
    fill: "#fecf2b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82 317c0-9 8-17 17-17H61c-3 0-6 3-6 6v22c0 3 3 6 6 6h38c-9 0-17-8-17-17zm0 0",
    fill: "#fabd2b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111 333H58c-5 0-10 4-10 9v71c20 26 44 48 73 65V342c0-5-5-9-10-9zm0 0",
    fill: "#ee3346"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M399 420c-20 0-36-16-36-36v98c27-15 52-36 72-60v-38c0 20-16 36-36 36zm0 0M242 420c-20 0-37-16-37-36v125a247 247 0 0 0 73 1V384c0 20-16 36-36 36zm0 0M85 420c-20 0-37-16-37-36v29c20 26 44 48 73 65v-94c0 20-17 36-36 36zm0 0",
    fill: "#db2640"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M92 180H77c-26 0-49-15-57-33v16c-3 37 27 66 57 66h15c30 0 60-29 58-66l-1-17c-8 18-31 34-57 34zm0 0M471 116c0-59-33-107-72-107s-72 48-72 107 32 107 72 107 72-48 72-107zm0 0",
    fill: "#deeefa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutlery);
export default __webpack_public_path__ + "static/media/cutlery.42f783888f70a68df32ba4d7186c34c8.svg";
export { ForwardRef as ReactComponent };